import * as React from 'react';
import { Wrapper, Text, Name } from './styled';
import { Header } from '@app/src/components/Header';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

const Welcome = () => {
  const alias = decodeAccessToken('alias');

  return(
    <Text>Bienvenido, <Name data-test="userAccountName">{alias}</Name></Text>
  );
};

interface Props {
  subTitle: string;
}

export const Title: React.FC<Props> = ({ subTitle }) => {
  const service = decodeAccessToken('service');
  return(
    <Wrapper>
      <Header
        title={'CallCenter PagoEfectivo / ' + service}
        renderComponent={Welcome}
        subTitle={subTitle}
      />
    </Wrapper>
  );
};
